/**
 @ngdoc service
 @name mapInterviewTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapInterviewTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            if(rawTileData.itemCorporateURI){
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkBusinessModelField('jobId', 'itemPrincipleURI', 'itemCorporateURI'));
            }
            else {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('jobId','itemPrincipleURI'));
            }
            tileFactory.addFieldToColumn1(tileFactory.field.newField('job'));
            tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('interviewer','interviewURI'));



            tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('address'));

            tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('supplierOrgUnitName','supplierOrgName'));
            if(tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationFieldWithLink('procurerOrgUnitName', 'procurerOrgName', 'businessURI'));
                tileFactory.addFieldToColumn2(tileFactory.field.newLinkField('candidateName', 'candidateURI'));
            }
            else{
                tileFactory.addFieldToColumn2(tileFactory.field.newField('candidateName'));
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('procurerOrgUnitName', 'procurerOrgName'));
            }


            tileFactory.addFieldToColumn3(tileFactory.field.newField('startDate', 'date'));
            var time = undefined;
            if(rawTileData.time){
                time = rawTileData.time.startTime + ' - ' + rawTileData.time.endTime;
            }
            tileFactory.addFieldToColumn3({label: objectTilesLabels.time.label, value: time});
            tileFactory.addFieldToColumn3(tileFactory.field.newTimeField('duration'));
            if(!tileFactory.isPrincipal()) {
                tileFactory.addFieldToColumn4(tileFactory.field.newTimeField('timeFromDistributionToInterviewCompleted'));
            }
            tileFactory.addFieldToColumn4(tileFactory.field.newField('reasons'));
            tileFactory.addFieldToColumn4(tileFactory.field.newInactiveField('candidatePhone', 'mobileOptout', 'mobileOptout'));
            tileFactory.addFieldToColumn4(tileFactory.field.newRankedInactiveField('managerPhone', [['ctpsBarring', 'ctpsBarring'], ['unsubscribedFromCalls', 'unsubscribedFromCalls']]));
            tileFactory.addTextField(tileFactory.textField.newTextField('feedback'));
            tileFactory.addTextField(tileFactory.textField.newTextField('comments'));


            // 4680: "Requested"
            // 4681: "Confirmed"
            // 4682: "Cancelled"
            // 4683: "Completed"
            // 4684: "Rejected"
            tileFactory.addStatus(tileFactory.status.newStatus('interviewStatus',
                [ tileFactory.LOOKUP_VALUE.INTERVIEW_STATUS_COMPLETED],
                [tileFactory.LOOKUP_VALUE.INTERVIEW_STATUS_CANCELLED, tileFactory.LOOKUP_VALUE.INTERVIEW_STATUS_REJECTED],
                [tileFactory.LOOKUP_VALUE.INTERVIEW_STATUS_REQUESTED,tileFactory.LOOKUP_VALUE.INTERVIEW_STATUS_CONFIRMED]
            ));

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapInterviewTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapInterviewTileService', mapInterviewTileService);
}());